import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-share-property-confirm-dialog",
  templateUrl: "./share-property-confirm-dialog.component.html",
  styleUrls: ["./share-property-confirm-dialog.component.scss"],
  standalone: false,
})
export class SharePropertyConfirmDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<SharePropertyConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
